import React from 'react'

interface SupTextProps {
  as?: React.ElementType | keyof JSX.IntrinsicElements
  children?: string
  className?: string
}

// Replaces brackets with numbers, ie [12], with <sup>12</sup>.
export const SupText = ({ as: Root = 'div', children, className }: SupTextProps) => (
  <Root className={className}>
    {children
      ?.split(/(\[[0-9]+\])/)
      .map((token, index) =>
        token.startsWith('[') && token.endsWith(']') ? (
          <sup key={index}>{token.slice(1, token.length - 1)}</sup>
        ) : (
          <React.Fragment key={index}>{token}</React.Fragment>
        )
      )}
  </Root>
)
